var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { downloader } from './downloader';
var fileSymbolMap = [
    {
        mimeType: 'image/jpeg',
        header: new Uint8Array([0xff, 0xd8]),
        sizeSymbol: new Uint8Array([0xff, 0xc0]),
        widthStartOffset: 3,
        widthEndOffset: 5,
        heightStartOffset: 5,
        heightEndOffset: 7,
    },
    {
        mimeType: 'image/png',
        header: new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]),
        sizeSymbol: new Uint8Array([0x49, 0x48, 0x44, 0x52]),
        widthStartOffset: 0,
        widthEndOffset: 4,
        heightStartOffset: 4,
        heightEndOffset: 8,
    },
];
/**
 * 判断数组 target 是否与数组 range 的开头部分匹配
 */
function isArrayStartWith(target, range) {
    for (var i = 0; i < target.length; i++) {
        if (target[i] !== range[i]) {
            return false;
        }
    }
    return true;
}
/**
 * 将 8 位无符号整数数组转换为十进制数字，按 big-endian
 */
function hexArrToOct(arr) {
    if (!arr.length) {
        return 0;
    }
    return arr.reduce(function (acc, cur, index) { return acc + cur * Math.pow(256, (arr.length - 1 - index)); }, 0);
}
/**
 * 计算 target 在 range 中的位置索引，索引值为匹配到 target 末尾位置的下一位
 */
function indexOfArray(target, range) {
    var index = -1;
    for (var i = 0; i < range.length; i++) {
        var offset = 0;
        for (var j = 0; j < target.length; j++) {
            if (range[i + offset] === undefined) {
                break;
            }
            if (target[j] === range[i + offset]) {
                offset++;
            }
        }
        if (offset >= target.length) {
            index = i;
            break;
        }
    }
    return index !== -1 ? index + target.length : -1;
}
function readArrayBuffer(blob) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        if (e.target) {
                            resolve(e.target.result);
                        }
                        else {
                            resolve(new ArrayBuffer(0));
                        }
                    };
                    reader.onerror = function () {
                        reject(new Error('读取文件失败'));
                    };
                    reader.readAsArrayBuffer(blob);
                })];
        });
    });
}
/**
 * 从文件头判断文件类型
 */
function getImageSymbol(view) {
    for (var i = 0; i < fileSymbolMap.length; i++) {
        var fileSymbol = fileSymbolMap[i];
        if (isArrayStartWith(fileSymbol.header, view.slice(0, fileSymbol.header.length))) {
            return fileSymbol;
        }
    }
    return null;
}
/**
 * 从文件头读取图片宽高
 */
function getImageSize(view, fileSymbol) {
    if (fileSymbol) {
        var index = indexOfArray(fileSymbol.sizeSymbol, view);
        var widthView = view.slice(index + fileSymbol.widthStartOffset, index + fileSymbol.widthEndOffset);
        var heightView = view.slice(index + fileSymbol.heightStartOffset, index + fileSymbol.heightEndOffset);
        var widthValue = hexArrToOct(widthView);
        var heightValue = hexArrToOct(heightView);
        return {
            width: widthValue,
            height: heightValue,
        };
    }
    return {
        width: 0,
        height: 0,
    };
}
/**
 * 获取图片信息，支持 blob 对象或远程地址
 */
export function getImageInfo(origin) {
    return __awaiter(this, void 0, void 0, function () {
        var blob, buffer, view, fileSymbol, size;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    blob = new Blob([]);
                    if (!(Object.prototype.toString.call(origin) === '[object String]')) return [3 /*break*/, 2];
                    return [4 /*yield*/, downloader(origin)];
                case 1:
                    blob = _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    if (Object.prototype.toString.call(origin) === '[object Blob]') {
                        blob = origin;
                    }
                    else {
                        throw new Error('参数不支持');
                    }
                    _a.label = 3;
                case 3: return [4 /*yield*/, readArrayBuffer(blob)];
                case 4:
                    buffer = _a.sent();
                    view = new Uint8Array(buffer);
                    fileSymbol = getImageSymbol(view);
                    size = getImageSize(view, fileSymbol);
                    return [2 /*return*/, {
                            url: URL.createObjectURL(blob),
                            mimeType: fileSymbol === null || fileSymbol === void 0 ? void 0 : fileSymbol.mimeType,
                            width: size.width,
                            height: size.height,
                        }];
            }
        });
    });
}
